// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2YhbN","additionalInfo":"AgreementModal_additionalInfo__3n8-S"};